<div class="grid gap-4">
  <!-- Who the case is for and where it stands (only the portals that are told it, so not a provider) -->
  @if (context()) {
    <mat-card class="rounded-3xl border border-slate-200 p-4 shadow-lg shadow-slate-200/60">
      <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-slate-500">Live context summary</h3>
      <dl class="grid gap-3">
        @for (row of rows(); track row.label) {
          <div>
            <dt class="text-xs font-medium uppercase tracking-wide text-slate-500">{{ row.label }}</dt>
            <dd class="text-sm font-semibold text-slate-900">
              @if (row.value) {
                {{ row.value }}
              } @else {
                <span class="font-normal text-slate-400">Not yet known</span>
              }
            </dd>
          </div>
        }
      </dl>
    </mat-card>
  }

  <!-- The latest things done on the case, and by whom -->
  <mat-card class="rounded-3xl border border-slate-200 p-4 shadow-lg shadow-slate-200/60">
    <div class="mb-3 flex items-center justify-between gap-2">
      <h3 class="text-sm font-semibold uppercase tracking-wide text-slate-500">Governance audit trail</h3>
      <span class="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600">ISO/POPIA</span>
    </div>
    @if (entries().length === 0) {
      <p class="text-sm text-slate-500">Nothing has been recorded yet.</p>
    } @else {
      <ol class="grid gap-3">
        @for (entry of entries(); track entry.id) {
          <li class="border-l-2 border-slate-200 pl-3">
            <p class="text-xs font-medium uppercase tracking-wide text-slate-500">
              {{ entry.changedDate | serverTime | date: 'd MMM y, HH:mm' }} · {{ entry.changedBy ?? 'System' }}
            </p>
            <p class="line-clamp-3 break-words text-sm text-slate-800" [attr.title]="entry.description">{{ entry.description || entry.action }}</p>
          </li>
        }
      </ol>
      <button mat-button type="button" class="mt-2" (click)="openHistory.emit()">View the full history</button>
    }
  </mat-card>
</div>
